export default __webpack_public_path__ + "e648a6c620e4e827927e18b821ee053d.jpg";